/* Import Redux Store */
import app from '../init/react/Bootstrapper'
import { getEstateList } from '../redux/modules/shortlist'
import loggedIn from '../shared/loggedIn'
/* Import Redux Store END */
import cssVars from 'css-vars-ponyfill'
import objectFitImages from 'object-fit-images'

import { scrollToAnchor } from 'scripts/util/dom'

window.addEventListener('load', () => {
  if (window.location.hash) {
    scrollToAnchor(window.location.hash)
  }
})

const dhsvCommon = {
  init() {
    this.setBodyWidth()
    this.loadNecessaryData()
    this.accordion()
    this.gravityDownlad()
    this.collapseWorkflow()
    this.initFooterCookieSettings()
    this.addFormInfoIcon()
    this.addDataLayerGFSubmit()
    this.preiseReportDataLayer()
    this.whitePaperDataLayer()
    objectFitImages()

    // const pathnames = [
    //   '/profil/tippgeber/formular',
    //   '/profil/suchende/ubersicht',
    //   '/profil/suchende/suchauftrage',
    //   '/profil/suchende/merkzettel',
    //   '/profil/tippgeber/formular',
    //   '/profil/tippgeber/formular/',
    //   '/profil/suchende/ubersicht/',
    //   '/profil/suchende/suchauftrage/',
    //   '/profil/suchende/merkzettel/',
    //   '/profil/tippgeber/formular/',
    // ]

    // if (pathnames.includes(window.location.pathname)) {
    //   document.body.classList.add('old-profile-design')
    // }
    $(document).on(
      'click',
      'a[href^="#"]:not([href="#"]):not([href^="#results"]):not(.collapse_ac)',
      e => scrollToAnchor(e.target.hash, e)
    )
  },

  addDataLayerGFSubmit() {
    $(document).on('gform_confirmation_loaded', function (e, form_id) {
      let art = $('#gform_confirmation_wrapper_' + form_id)
        .closest('.gform_data_layer')
        .data('art')
      let referrer = $('#gform_confirmation_wrapper_' + form_id)
        .closest('.gform_data_layer')
        .data('referrer')
      window.dataLayer.push({
        event: 'kontakt-anfrage-absenden',
        'DL_kontaktformular-art': art,
        'DL_kontaktformular-referrer': referrer,
      })
    })
  },
  addFormInfoIcon() {
    const text = 'Für die Zusendung der Angebote/Exposés erforderlich.'
    const fields = document.querySelectorAll('.sendrequired-info')
    fields.forEach(field => {
      const inputContainer = field.querySelector('.ginput_container')
      if (inputContainer) {
        const inputInnerHTML = inputContainer.innerHTML
        inputContainer.innerHTML = `<div class="info-popup"><span class="icon">i</span><span class="text">${text}</span></div>${inputInnerHTML}`
      }
    })
  },
  preiseReportDataLayer() {
    let hash = window.location.hash
    if (hash && hash.includes('preisreport-')) {
      hash = hash.replace('#', '')
      window.dataLayer.push({
        event: 'preisreport-ansehen',
        'preisreport-name': hash,
      })
    }
  },
  whitePaperDataLayer() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const insertLayer = urlParams.get('insertLayer')
    if (insertLayer) {
      const art = urlParams.get('art')
      window.dataLayer.push({
        event: 'whitepaper-download',
        'kontaktformular-name': art,
      })
    }
  },
  onResize() {
    $(window).on('resize', () => {
      this.setBodyWidth()
    })
  },
  setBodyWidth() {
    cssVars({
      variables: { '--body-width': document.body.clientWidth + 'px' },
    })
  },
  loadNecessaryData() {
    const store = app.getStore()
    const state = store.getState()
    const { dispatch } = store

    if (loggedIn && !state.shortlist.isLoaded) {
      dispatch(getEstateList())
    }
  },
  accordion() {
    // Initialize ARIA and focusability for both new (button) and legacy markup
    const $titles = $('.accordion-item .accordion-item__title')
    $titles.each(function () {
      const $title = $(this)
      const $item = $title.parents('.accordion-item')
      const $content = $item.find('.accordion-item__content').first()
      const $button = $title.find('.accordion-item__button').first()
      const isOpen = $item.hasClass('toggle') || $content.is(':visible')

      if ($button.length) {
        // Ensure button has ARIA linkage
        const btnId =
          $button.attr('id') ||
          `accordion-button-${Math.random().toString(36).slice(2, 9)}`
        const panelId =
          $content.attr('id') ||
          `accordion-panel-${Math.random().toString(36).slice(2, 9)}`
        $button.attr({
          id: btnId,
          'aria-controls': panelId,
          'aria-expanded': isOpen ? 'true' : 'false',
        })
        $content.attr({
          id: panelId,
          role: 'region',
          'aria-labelledby': btnId,
        })
        if (isOpen) {
          $content.removeAttr('hidden')
        } else {
          $content.attr('hidden', '')
        }
      } else {
        // Legacy: make title act as a button
        const titleId =
          $title.attr('id') ||
          `accordion-legacy-button-${Math.random().toString(36).slice(2, 9)}`
        const panelId =
          $content.attr('id') ||
          `accordion-legacy-panel-${Math.random().toString(36).slice(2, 9)}`
        $title.attr({
          id: titleId,
          role: 'button',
          tabindex: '0',
          'aria-controls': panelId,
          'aria-expanded': isOpen ? 'true' : 'false',
        })
        $content.attr({
          id: panelId,
          role: 'region',
          'aria-labelledby': titleId,
        })
        if (isOpen) {
          $content.removeAttr('hidden')
        } else {
          $content.attr('hidden', '')
        }
        // Keyboard support for legacy title
        $title.on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            $title.trigger('click')
          }
        })
      }
    })

    // Click handler (works for both new and legacy)
    $('.accordion-item .accordion-item__title').on('click', function () {
      const $title = $(this)
      const $item = $title.parents('.accordion-item')
      const $content = $item.find('.accordion-item__content').first()
      const $button = $title.find('.accordion-item__button').first()

      const willOpen = !$item.hasClass('toggle')

      // Sync ARIA first
      if ($button.length) {
        $button.attr('aria-expanded', willOpen ? 'true' : 'false')
      } else {
        $title.attr('aria-expanded', willOpen ? 'true' : 'false')
      }

      // Stop any running animation
      $content.stop(true, true)

      if (willOpen) {
        $title.addClass('active')
        $item.addClass('toggle')
        $content.removeAttr('hidden')
        $content.slideDown(200)
      } else {
        $title.removeClass('active')
        $content.slideUp(200, function () {
          $item.removeClass('toggle')
          $content.attr('hidden', '')
        })
      }
    })
  },
  gravityDownlad() {
    $(document).bind('gform_confirmation_loaded', function (event, formId) {
      if (formId === 7 || formId === 10) {
        let download = $('.modal.fade.show').attr('data-file')
        let link = document.createElement('a')
        var filename = download.replace(/^.*[\\/]/, '')
        link.href = download
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        $('.download-pdf').attr('data-toggle', '')
        $('.rt-modal__inner-toppanel-close').trigger('click')
      } else if (formId === 3) {
        $('.dhsv_gutenberg_forms__header').hide()
      }
    })
  },
  collapseWorkflow() {
    $('.workflow-collapse-add .workflow-item').on('click', function () {
      let $toggleBtn = $(this).find('.workflow-item__content-inner__toggle')
      $toggleBtn.next().slideToggle()
      $(this).toggleClass('active')
    })
    $('.workflow-collapse__toggle').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        let items = $(this)
          .parents('.workflow-collapse-add')
          .find('.workflow-item.active')
        items.removeClass('active')
        items
          .find(
            '.workflow-item__content-inner .workflow-item__content-inner__toggle + p'
          )
          .slideUp()
      } else {
        $(this).addClass('active')
        let items = $(this)
          .parents('.workflow-collapse-add')
          .find('.workflow-item:not(.active)')
        items.addClass('active')
        items
          .find(
            '.workflow-item__content-inner .workflow-item__content-inner__toggle + p'
          )
          .slideDown()
      }
    })
  },
  initFooterCookieSettings() {
    $('footer .service-menu .cookie-settings').on('click', function (e) {
      e.preventDefault()
      if (
        typeof window.__cmp !== 'undefined' &&
        typeof window.__cmp === 'function'
      ) {
        const x = window.__cmp('consentStatus')

        if (x.consentExists) {
          window.__cmp('showScreenAdvanced')
        }
      }
      // if (typeof window.Cookiebot !== 'undefined') {
      //   window.Cookiebot.renew()
      // }
    })
  },
}

export default {
  init() {
    // JavaScript to be fired on all pages
    dhsvCommon.init()
    dhsvCommon.onResize()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
